import * as React from "react";

import { Button } from "semantic-ui-react";

import { immunisationApi } from "../../immunisation/immunisationApi";

import { ActionableTaskButtonProps } from "./ActionableTaskButtons";

import { Link } from "redux-little-router";

const ViewImmsClearanceButton: React.FunctionComponent<ActionableTaskButtonProps> = (props) => {
    const onViewCase = () => immunisationApi.viewImmsClearance(props.task.caseId, props.task.id);

    return (
        <Link href={`/actions/${props.task.employeeId}/${props.task.caseId}/immunisation-clear-certificate/${props.task.id}`} onClick={onViewCase}>
            <Button
                secondary
                content="View"
            />
        </Link>
    );
};

export { ViewImmsClearanceButton };
